import 'select2';
import '../sass/main.scss';
import { createCookie, eraseCookie, getUrlParameter, readCookie } from './helpers';
import NotificationManager from './notifications.js';

(($) => {
    window.notificationManager = new NotificationManager();

    // Frame-Busting
    if (top != window) {
        window.document.write(`<div style=
            'background: black;
            opacity: 0.25; filter: alpha(opacity = 25);
            position: absolute; top: 0px; left: 0px;
            width: 9999px; height: 9999px;
            z-index: 1000001'
            onClick='top.location.href=window.location.href'>
        </div>`);
    }

    const business_area_cookie = 'business-area',
        search_area_selector = 'search-jobs-type',
        default_business_area_cookie = 'default-business-area',
        default_saveletter_cookie = 'default-save-letter',
        business_area_selector = $('#business-area-selector'),
        specialCharacterRegex = /[^a-zA-Z0-9,+\\-\s]/g,
        globals = {
            wp_admin_url: ajaxpagination.ajaxurl,
        };

    // genric swiper funcyion
    let listToMdSwiperOptions;
    const swiperInstances = [];

    $('.list-to-swiper').each(function (index, element) {
        let $swiperContainer = $(element);
        let $swiperWrapper = $swiperContainer.find('.swiper-wrapper');
        let $dataAttributes = $swiperContainer.data();
        const isLatestNewsSlider = $swiperContainer.hasClass('latest-news-slider');
        const isLocationSlider = $swiperContainer.hasClass('locations-container');
        const meetTheTeamSlider = $swiperContainer.hasClass('team-grid-slider');

        const slideCount = $swiperWrapper.find('.swiper-slide').length;

        listToMdSwiperOptions = {
            slidesPerView: $dataAttributes.slideSmCount ?? 1.1,
            spaceBetween: $swiperContainer.data('space-between-mobile') ?? 24,
            observer: isLatestNewsSlider || meetTheTeamSlider ? true : false,
            watchSlidesProgress: isLatestNewsSlider || meetTheTeamSlider ? true : false,
            cssMode: true,
            preventClicks: false,
            preventClicksPropagation: false,
            autoHeight: $dataAttributes.autoheight !== undefined ? $dataAttributes.autoheight : false,
            loop: isLocationSlider
                ? false
                : slideCount > 3 || $dataAttributes.slideLgCount === 1
                  ? $dataAttributes.loop !== undefined
                      ? $dataAttributes.loop
                      : true
                  : false,
            a11y: {
                slideRole: 'region',
                slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
            },
            ...(isLatestNewsSlider ||
                (meetTheTeamSlider && {
                    grid: {
                        fill: 'row',
                        rows: $dataAttributes.smRows ?? 1,
                    },
                })),
            navigation: {
                nextEl: $swiperContainer.find('.swiper-button-next').get(0),
                prevEl: $swiperContainer.find('.swiper-button-prev').get(0),
            },
            pagination: {
                el: $swiperContainer.find('.swiper-pagination').get(0),
                type: $swiperContainer.data('pagination') ?? 'bullets',
                clickable: true,
            },
            breakpoints: {
                767: {
                    slidesPerView: $dataAttributes.slideMdCount ?? 1,
                    ...(isLatestNewsSlider ||
                        (meetTheTeamSlider && {
                            grid: {
                                fill: 'row',
                                rows: $dataAttributes.mdRows ?? 1,
                            },
                        })),
                },
                992: {
                    observer: true,
                    watchSlidesProgress: true,
                    cssMode: isLocationSlider ? false : true,
                    slidesPerView: $dataAttributes.slideLgCount || 3,
                    spaceBetween: $swiperContainer.data('space-between') ?? 24,
                    ...(isLatestNewsSlider || isLocationSlider || meetTheTeamSlider
                        ? {
                              grid: {
                                  fill: 'row',
                                  rows: $dataAttributes.lgRows ?? 1,
                              },
                          }
                        : {}),
                },
            },
            on: {
                init: function (swiper) {
                    updateTabIndexForSlides(swiper);
                    if ($(element).find('.swiper-pagination-fraction').length > 0) {
                        updateNumbersPaginationInner(element);
                    }
                },
                afterInit: function () {
                    $swiperWrapper.removeAttr('aria-live');
                },
                slidesUpdated: function (swiper) {
                    updateTabIndexForSlides(swiper);
                    if ($(element).find('.swiper-pagination-fraction').length > 0) {
                        updateNumbersPaginationInner(element);
                    }
                },
                slideChangeTransitionEnd: function () {
                    if ($(element).find('.swiper-pagination-fraction').length > 0) {
                        updateNumbersPaginationInner(element);
                    }
                },
                slideChange: function () {
                    if ($(element).find('.swiper-pagination-fraction').length > 0) {
                        updateNumbersPaginationInner(element);
                    }
                },
            },
        };

        // Set loop false, if there is only one slide. This is to avoid "Child items not clickable issue".
        if($swiperContainer.find('.swiper-slide').length <= 1) {
            listToMdSwiperOptions.loop = false;
        }

        const swiperInstance = new Swiper($swiperContainer.get(0), listToMdSwiperOptions);
        swiperInstances.push(swiperInstance);
        swiperInstance.update(); // Update Swiper instance
    });

    function updateAllSwipers() {
        swiperInstances.forEach((swiper) => {
            swiper.update();
            updateTabIndexForSlides(swiper); // Update tabindex for each swiper
        });
    }

    function updateNumbersPaginationInner(element) {
        const currentCount = $(element).find('.swiper-pagination-current')[0].innerText;
        const totalCount = $(element).find('.swiper-pagination-total')[0].innerText;

        if (totalCount > 1) {
            $(element).find('.slide-count-wrap').removeClass('hidden');
        } else {
            $(element).find('.slide-count-wrap').addClass('hidden');
        }

        $(element).find('.slide-count-wrap .current').text(currentCount);
        $(element).find('.slide-count-wrap .total').text(totalCount);
    }

    let navListSwiper;
    if ($('.nav-list-swiper').length > 0 && $(window).width() > 1024) {
        initializeSecondaryNavSwiper();
    }

    $('.nav-list-swiper .swiper-slide a').on('click', function () {
        $('.nav-list-swiper .swiper-slide a').removeClass('active');
        $(this).addClass('active');
    });

    function initializeSecondaryNavSwiper() {
        let $dataAttributes = $('.nav-list-swiper').data();

        navListSwiper = new Swiper('.nav-list-swiper', {
            slidesPerView: $dataAttributes.slideCount !== undefined ? $dataAttributes.slideCount : 'auto',
            freeMode: $dataAttributes.freeMode ?? 'true',
            spaceBetween: $dataAttributes.spaceBetween ?? 60,
            centerMode: true,
            centeredSlidesBounds: true,
        });
    }

    function swiperWithThumbs() {
        let thumbSlidesCount = document.querySelectorAll('.swiper-thumbs .swiper-slide').length;
        var swiperThumbs = new Swiper('.swiper-thumbs', {
            spaceBetween: 0,
            slidesPerView: thumbSlidesCount > 5 ? 5 : thumbSlidesCount,
            watchSlidesProgress: true,
        });

        let $swiperWrapper = $('.swiper-thumbs-view').find('.swiper-wrapper');
        let $dataAttributes = $('.swiper-thumbs-view').data();

        var swiperThumbsView = new Swiper('.swiper-thumbs-view', {
            autoHeight: true,
            spaceBetween: 10,
            thumbs: {
                swiper: swiperThumbs,
            },
            on: {
                init: function () {
                    $swiperWrapper.children('.swiper-slide').each(function () {
                        let $slide = $(this);
                        if ($slide.hasClass('swiper-slide-active') || $slide.hasClass('swiper-slide-fully-visible')) {
                            $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                        } else {
                            $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                        }
                    });
                },
                slidesUpdated: function () {
                    $swiperWrapper.children('.swiper-slide').each(function () {
                        let $slide = $(this);
                        if ($slide.hasClass('swiper-slide-active') || $slide.hasClass('swiper-slide-fully-visible')) {
                            $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                        } else {
                            $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                        }
                    });
                },
                slideChangeTransitionEnd: function () {
                    $swiperWrapper.children('.swiper-slide').each(function () {
                        let $slide = $(this);
                        if ($slide.hasClass('swiper-slide-active') || $slide.hasClass('swiper-slide-fully-visible')) {
                            $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                        } else {
                            $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                        }
                    });
                },
            },
        });
    }

    swiperWithThumbs();

    // Tab to thumb slider
    var swiperTabThumbs;
    var swiperTabThumbView;

    function swiperTabThumbSlider() {
        let $swiperThumbWrapper = $('.swiper-tab-thumbs').find('.swiper-wrapper');
        let $dataThumbAttributes = $('.swiper-tab-thumbs').data();

        let checkDirectionVertical = () => $swiperThumbWrapper.parents('.dir-vertical').length > 0;
        let directionVertical = checkDirectionVertical();
        let slideCount = $swiperThumbWrapper.find('.swiper-slide').length;

        swiperTabThumbs = new Swiper('.swiper-tab-thumbs', {
            spaceBetween: slideCount === 1 ? 0 : 30,
            centeredSlides: true,
            slidesPerView: directionVertical ? 'auto' : 1.8,
            centerMode: true,
            slideToClickedSlide: true,
            centerInsufficientSlides: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            allowTouchMove: false,
            navigation: {
                nextEl: '.programme-thumb-next',
                prevEl: '.programme-thumb-prev',
            },
            breakpoints: {
                480: {
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                    centeredSlides: false,
                    centerInsufficientSlides: false,
                    watchSlidesVisibility: false,
                    watchSlidesProgress: false,
                    cssMode: true,
                    allowTouchMove: true,
                },
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 80,
                    centeredSlides: false,
                },
            },
            on: {
                click: function () {
                    $swiperThumbWrapper.children('.swiper-slide').on('click', function (e) {
                        var ariaLabel = $(this).closest('.swiper-slide').attr('aria-label');
                        var slideIndex = parseInt(ariaLabel.match(/\d+/)[0]);
                        if (swiperTabThumbs) {
                            swiperTabThumbs.slideTo(slideIndex - 1, 300);
                        }
                        e.preventDefault(); // Prevent the default action for the clicked element
                    });
                },
                init: function () {
                    var swiper = this;

                    setTimeout(function () {
                        swiper.slideTo(0);
                    }, 100); // this is used for slider in magnific popup
                    if ($(window).width() < 480) {
                        $swiperThumbWrapper.children('.swiper-slide').each(function () {
                            let $slide = $(this);
                            if ($slide.hasClass('swiper-slide-active')) {
                                $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                                $(this).addClass('active');
                            } else {
                                $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                            }
                        });
                    }
                },
                slidesUpdated: function () {
                    if ($(window).width() < 480) {
                        $swiperThumbWrapper.children('.swiper-slide').each(function () {
                            let $slide = $(this);
                            if ($slide.hasClass('swiper-slide-active')) {
                                $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                                $(this).addClass('active');
                            } else {
                                $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                            }
                        });
                    }
                },
                slideChangeTransitionEnd: function () {
                    if ($(window).width() < 480) {
                        $swiperThumbWrapper.children('.swiper-slide').each(function () {
                            let $slide = $(this);
                            if ($slide.hasClass('swiper-slide-active')) {
                                $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                                $(this).find('button').trigger('click');
                            } else {
                                $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                            }
                        });
                        $swiperThumbWrapper.children('.swiper-slide-active').find('button').focus();
                    }
                },
            },
        });

        let $swiperWrapper = $('.swiper-tab-thumbs-view').find('.swiper-wrapper');
        let $dataAttributes = $('.swiper-tab-thumbs-view').data();

        swiperTabThumbView = new Swiper('.swiper-tab-thumbs-view', {
            autoHeight: true,
            allowTouchMove: false,
            effect: 'fade',
            spaceBetween: 10,
            fadeEffect: {
                crossFade: true,
            },
            thumbs: {
                swiper: swiperTabThumbs,
            },
            navigation: {
                nextEl: '.programme-thumb-next',
                prevEl: '.programme-thumb-prev',
            },
            on: {
                init: function () {
                    var swiper = this;
                    setTimeout(function () {
                        swiper.slideTo(0);
                    }, 100); // this is used for slider in magnific popup
                    $swiperWrapper.children('.swiper-slide').each(function () {
                        let $slide = $(this);
                        if ($slide.hasClass('swiper-slide-active') || $slide.hasClass('swiper-slide-fully-visible')) {
                            $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                        } else {
                            $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                        }
                    });
                },
                slidesUpdated: function () {
                    $swiperWrapper.children('.swiper-slide').each(function () {
                        let $slide = $(this);
                        if ($slide.hasClass('swiper-slide-active') || $slide.hasClass('swiper-slide-fully-visible')) {
                            $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                        } else {
                            $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                        }
                    });
                },
                slideChangeTransitionEnd: function () {
                    $swiperWrapper.children('.swiper-slide').each(function () {
                        let $slide = $(this);
                        if ($slide.hasClass('swiper-slide-active') || $slide.hasClass('swiper-slide-fully-visible')) {
                            $slide.removeAttr('aria-hidden').find('a, button').removeAttr('tabindex');
                            swiperTabThumbs?.update();
                        } else {
                            $slide.attr('aria-hidden', 'true').find('a, button').attr('tabindex', -1);
                        }
                    });
                    // For schemes tabs hub pages
                    if ($swiperThumbWrapper.parents('.schemes-container').length > 0) {
                        $('.slide-view-content [aria-expanded="true"]')
                            .attr('aria-expanded', 'false')
                            .removeClass('opened');
                        $('.slide-view-content [aria-hidden="false"]').attr('aria-hidden', 'true').css('height', '0');
                    }
                },
            },
        });
    }

    $('.swiper-tab-thumbs .swiper-slide button').on('click', function (e) {
        let ariaLabelSlide = $(this).closest('.swiper-slide').attr('aria-label');
        let slideIndexPos = parseInt(ariaLabelSlide?.match(/\d+/)[0]);
        swiperTabThumbs?.slideTo(slideIndexPos - 1, 300);
        swiperTabThumbView?.slideTo(slideIndexPos - 1, 300);
    });

    swiperTabThumbSlider();
    // Tab to thumb slider end

    const initLatestStoriesSwiper = ($swiperSelector) => {
        const $swiperContainer = $($swiperSelector);
        const $swiperWrapper = $swiperContainer.find('.swiper-wrapper');
        const $dataAttributes = $swiperContainer.data();

        new Swiper($swiperSelector, {
            slidesPerView: $dataAttributes.slideSmCount ?? 1.1,
            spaceBetween: $swiperContainer.data('space-between-mobile') ?? 24,
            cssMode: true,
            a11y: {
                slideRole: 'region',
                slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
            },
            grid: {
                fill: 'row',
                rows: $dataAttributes.smRows ?? 1,
            },
            navigation: {
                nextEl: $swiperContainer.find('.latest-stories-slider-next').get(0),
                prevEl: $swiperContainer.find('.latest-stories-slider-prev').get(0),
            },
            breakpoints: {
                767: {
                    slidesPerView: $dataAttributes.slideMdCount ?? 1,
                    grid: {
                        fill: 'row',
                        rows: $dataAttributes.mdRows ?? 1,
                    },
                },
                992: {
                    slidesPerView: $dataAttributes.slideLgCount ?? 3,
                    spaceBetween: $swiperContainer.data('space-between') ?? 24,
                    cssMode: true,
                    grid: {
                        fill: 'row',
                        rows: $dataAttributes.lgRows ?? 1,
                    },
                },
            },
            on: {
                afterInit: function () {
                    updateTabIndexForSlides(this);
                },
            },
        });
    };

    // Check for non-ajax based latest stories slider
    {
        const $swiperSelector = '.latest-stories-container[data-ajax="false"] .latest-stories-slider';
        const $swiperContainer = $($swiperSelector);

        if ($swiperContainer.length > 0) {
            initLatestStoriesSwiper($swiperSelector);
            window.addEventListener('offline', initLatestStoriesSwiper($swiperSelector));
        }
    }

    function loadLatestStories(bussiness_area_slug, bussiness_area_name) {
        const $swiperSelector = '.latest-stories-container:not([data-ajax="false"])';
        const $swiperContainer = $($swiperSelector);
        const $swiperWrapper = $swiperContainer.find('.swiper-wrapper');
        const $loader = $swiperContainer.find('.box-loader');

        // Check if wrapper element is available on page
        if ($swiperWrapper.length === 0) return;

        $.ajax({
            url: globals.wp_admin_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'get_latest_stories',
                style: $swiperWrapper.data('style'),
                filter_by: $swiperWrapper.data('filter_by'),
                tags: $swiperWrapper.data('tags'),
                categories: $swiperWrapper.data('categories'),
                child_category: $swiperWrapper.data('child_cat'),
                bussiness_area_slug: bussiness_area_slug,
                bussiness_area_name: bussiness_area_name,
            },
            beforeSend: function () {
                $loader.show();
            },
            success: (res) => {
                if (res.success) {
                    $swiperWrapper.html(res.data);
                    initLatestStoriesSwiper(`${$swiperSelector} .latest-stories-slider`);
                }
            },
            error: function () {},
            complete: function () {
                $loader.hide();
            },
        });
    }

    function loadLatestJobs(bussiness_area_slug, bussiness_area_name) {
        const wrapper = $('.latest-jobs-container .latest-jobs-slider .swiper-wrapper'),
            loader = $('.latest-jobs-container .box-loader');
        let is_search_selected = readCookie(search_area_selector);
        var job_type = 'external';
        if (is_search_selected) {
            job_type = is_search_selected;
        }
        // Check if wrapper element is available on page
        if (wrapper.length === 0) return;

        $.ajax({
            url: globals.wp_admin_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'get_latest_jobs',
                by_business_area: 1,
                bussiness_area_slug: bussiness_area_slug,
                bussiness_area_name: bussiness_area_name,
                job_type: job_type,
            },
            beforeSend: function () {
                loader.show();
            },
            success: (res) => {
                if (res.success) {
                    wrapper.html(res.data);
                    let $swiperContainer = $('.latest-jobs-slider');
                    let $swiperWrapper = $swiperContainer.find('.swiper-wrapper');
                    let $dataAttributes = $swiperContainer.data();
                    new Swiper('.latest-jobs-slider', {
                        slidesPerView: $dataAttributes.slideSmCount ?? 1.1,
                        spaceBetween: $swiperContainer.data('space-between-mobile') ?? 24,
                        cssMode: true,
                        a11y: {
                            slideRole: 'region',
                            slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
                        },
                        grid: {
                            fill: 'row',
                            rows: $dataAttributes.smRows ?? 1,
                        },
                        navigation: {
                            nextEl: $swiperContainer.find('.latest-jobs-slider-next').get(0),
                            prevEl: $swiperContainer.find('.latest-jobs-slider-prev').get(0),
                        },
                        breakpoints: {
                            767: {
                                slidesPerView: $dataAttributes.slideMdCount ?? 1,
                                grid: {
                                    fill: 'row',
                                    rows: $dataAttributes.mdRows ?? 1,
                                },
                            },
                            992: {
                                slidesPerView: $dataAttributes.slideLgCount ?? 3,
                                spaceBetween: $swiperContainer.data('space-between') ?? 24,
                                grid: {
                                    fill: 'row',
                                    rows: $dataAttributes.lgRows ?? 1,
                                },
                            },
                        },
                        on: {
                            init: function (swiper) {
                                updateTabIndexForSlides(swiper);
                                swiper.update();
                            },
                        },
                    });
                } else {
                    $('.latest-jobs-container .latest-jobs-slider').removeClass('equal-height-slides');
                    $('.latest-jobs-container .latest-jobs-slider .swiper-nav-wrapper').remove();
                    wrapper.html(res.data);
                }
            },
            error: function () {},
            complete: function () {
                loader.hide();
            },
        });
    }

    function getLatestJobsCount() {
        const countWrapper = $('.latest_count .btn');

        countWrapper.prepend('<div class="loader_wrap"><div class="loader">Loading...</div></div>');
        var job_type = 'external';
        var linkHref = $('.latest_count a.btn').attr('href');
        var urlParams = new URLSearchParams(linkHref);
        var urlParamsObject = {};
        urlParams.forEach(function (value, key) {
            if (key.indexOf('?submit') == -1) {
                urlParamsObject[key] = value;
            }
        });

        var serializedData = $.param(urlParamsObject);
        $.ajax({
            type: 'POST',
            url: globals.wp_admin_url,
            data: {
                action: 'get_career_latest_count',
                data: serializedData,
            },
            cache: false,
            success: function (res) {
                countWrapper.find('.loader_wrap').remove();
                var latestCountAnchor = $('.latest_count a');
                var jobCount = '';
                if (res != '') {
                    jobCount = $('<div>').html(res).find('.jobs-count').text();
                }
                latestCountAnchor.attr(
                    'aria-label',
                    `current vacancies ${jobCount} click here to explore more ${latestCountAnchor.data('title')}`
                );
                $('.latest_count a.btn').append(res);
            },
        });

        return false;
    }

    function getPopularLocations() {
        const $locationsContainer = $('.popular-locations .locations-container');
        const locations = $('.popular-locations .locations-container').data('locations');
        $.ajax({
            type: 'POST',
            url: globals.wp_admin_url,
            data: {
                action: 'get_popular_locations',
                locations: locations,
            },
            cache: false,
            success: function (res) {
                if (res != '') {
                    $('.popular-locations .locations-container .swiper-wrapper').html(res);

                    const swiperInstance = swiperInstances.find((swiper) => swiper.el === $locationsContainer.get(0));

                    if (swiperInstance) {
                        swiperInstance.update(); // Update Swiper instance
                        updateTabIndexForSlides(swiperInstance); // Apply tabindex logic
                    } else {
                        console.error('Swiper instance not found for the updated container');
                    }
                }
            },
            error: function (e) {
                console.error(e);
            },
        });

        return false;
    }

    function loadBusinessAreaData(slug, name, theme_color) {
        if (!navigator.onLine) return;
        createCookie(
            business_area_cookie,
            JSON.stringify({
                slug: slug,
                name: name,
                theme_color: theme_color,
            })
        );

        // Set theme color to body tag
        document.body.style.setProperty('--business-area-theme-color', theme_color);

        // Update the business area name in URL of search job buttons.
        $('.business-area-specific-button').each(function () {
            const base_url = new URL($(this).data('base-url'));
            base_url.searchParams.append('business_area', name);
            $(this).attr('href', base_url.href);
        });

        // Update state name in all product blocks on the page
        $('.current-business-area').text(name);
        $('body').attr('data-business-area', slug);

        loadLatestJobs(slug, name);
        loadLatestStories(slug, name);

        // Send new tag to notification service
        notificationManager.sendTag('business_area', slug);
    }

    function getSearchPageUrl() {
        const searchCookie = readCookie('default-search-cookie');

        if (searchCookie) {
            const searchQuery = JSON.parse(decodeURIComponent(searchCookie));
            let data = {};
            const unwantedData = ['show', 'submit', 'address', 'sort_by'];
            let searchPageUrl = homeUrl + '/search-jobs/?submit=1&';

            for (const [key, value] of Object.entries(searchQuery.data)) {
                if (value && !unwantedData.includes(key)) {
                    let val;
                    if (value.includes(',')) {
                        val = value.split(',').map((v) => v.trim());
                    } else {
                        val = value;
                    }
                    data[key] = val;
                    searchPageUrl += `${key}=${encodeURIComponent(Array.isArray(val) ? val.join(',') : val)}&`;
                }
            }

            let searchButtonLink = searchPageUrl.slice(0, -1);
            let roiLink = '';

            if (data.business_area && data.business_area.includes('ROI')) {
                roiLink = '&location=ireland';
            }

            searchButtonLink += roiLink;
            data['business_area'] = Array.isArray(data['business_area'])
                ? data['business_area'].join(', ')
                : data['business_area'] || '';

            return {
                search_button_link: searchButtonLink,
                search_data: data,
            };
        }
        return null;
    }

    function getLastSearchedData() {
        const searchData = getSearchPageUrl();

        if (searchData) {
            const text = `Search ${searchData.search_data.business_area ? 'for ' + searchData.search_data.business_area + ' ' : ''}jobs${searchData.search_data.location ? ' in ' + searchData.search_data.location : ''}`;
            $('.cookie_search_wrapper .btn').attr('href', searchData.search_button_link);
            $('.cookie_search_wrapper .btn').text(text);
            $('.cookie_search_wrapper').removeClass('hidden');
        }
    }

    // Add top spacing for main content wrapper
    {
        const headerResizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const headerHeight = jQuery(entry.target).outerHeight();
                const topbarHeight = $('.top-bar').outerHeight();
                let additional_wrapper_padding = 0;

                if ($('#hub-nav-sticky').length > 0) {
                    additional_wrapper_padding += $('#hub-nav-sticky').outerHeight();
                }

                // Wrapper top spacing for Why Boots pages.
                let bodyPadding = headerHeight + topbarHeight + additional_wrapper_padding;
                if ($('body').hasClass('why-boots')) {
                    bodyPadding = 0;
                }
                jQuery('body .wrapper').css('padding-top', bodyPadding);

                // Secondary header position
                const headerTotalHeight = headerHeight + (jQuery('.top-bar').is(':visible') ? topbarHeight : 0);

                // Stories listing - Secondary header position
                $('.category-filter').css('top', headerTotalHeight);

                // Hub pages - Secondary navigation
                $('#hub-nav-sticky').css('top', headerTotalHeight);

                // Job listing - Secondary navigation
                $('.search-jobs .form-selection-nav-section').css('top', headerTotalHeight);

                // Why Boots home page - Sticky secondary navigation
                if ($('.vertical-slides').length > 0) {
                    $('#why-boots-nav').css('top', headerTotalHeight);
                }
            }
        });

        headerResizeObserver.observe(document.querySelector('.main-header .nav'));
    }

    /**
     * Business area based theme setup
     */
    // Business area change handler
    business_area_selector.on('change', function (e) {
        const slug = $(this).val(),
            name = $(this).find('option:selected').text(),
            theme_color = $(this).find('option:selected').data('color');
        loadBusinessAreaData(slug, name, theme_color);
    });

    try {
        let selected_business_area = JSON.parse(readCookie(business_area_cookie));

        if (!selected_business_area || !selected_business_area.slug) {
            selected_business_area = JSON.parse(
                decodeURIComponent(readCookie(default_business_area_cookie).replace(/\+/g, '%20'))
            );
        }

        if (business_area_selector.length > 0) {
            business_area_selector.val(selected_business_area.slug).trigger('change');
        } else {
            loadBusinessAreaData(
                selected_business_area.slug,
                selected_business_area.name,
                selected_business_area.theme_color
            );
        }
    } catch (e) {
        business_area_selector.trigger('change');
    }

    // Programmes widget
    {
        $.each($('.programmes-wrapper'), function (_, e) {
            const wrapper = e,
                nav_wrapper = $(wrapper).find('.programmes-navigation-wrapper'),
                content_wrapper = $(wrapper).find('.programmes-content-wrapper');

            nav_wrapper.find('.swiper-tab-thumbs .swiper-slide').on('click', function () {
                const ele = $(this);

                // Store theme color in css variable.
                wrapper.style.setProperty('--programme-theme-color', ele.find('.programme').data('color'));

                // On desktop set top spacing and scroll to active element
                if ($(window).width() > 767) {
                    content_wrapper
                        .find(`#${ele.find('.programme').data('id')}`)
                        .closest('.swiper-slide')
                        .css('padding-top', ele.find('.programme').offset().top - nav_wrapper.offset().top);
                }
            });

            // Activate first element on load.
            nav_wrapper.find('.title-wrapper button').first().trigger('click');
        });
    }

    // Story card redirect on image click
    $(document).on('click', '.clickable-card-image-wrapper', function () {
        let linkURL = $(this).parents('.clickable-img-card').find('.card-main-link').attr('href');
        $(this).parents('.clickable-img-card').find('.card-main-link').trigger('click');
    });

    // Content popup
    $('.content-popup-trigger').magnificPopup({
        type: 'inline',
        closeBtnInside: true,
        autoFocusLast: true,
        fixedBgPos: true,
        fixedContentPos: true,
        callbacks: {
            open: function () {
                let self = this;
                setTimeout(function () {
                    let swiperContainer = self.content.find('.swiper-container');

                    if (swiperContainer.length > 0 && swiperContainer[0].swiper) {
                        swiperContainer[0].swiper.destroy(true, true);
                    }
                    swiperContainer
                        .find('.swiper-slide')
                        .removeClass('swiper-slide-visible swiper-slide-active swiper-slide-next swiper-slide-prev');

                    swiperTabThumbSlider();

                    let newSwiperInstance = swiperContainer[0].swiper;
                    if (newSwiperInstance) {
                        newSwiperInstance.update();
                        newSwiperInstance.slideTo(0);
                    }
                }, 100);
            },
        },
    });

    // video popup
    $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade yt-iframe-modal',
        preloader: true,
        closeBtnInside: false,
        autoFocusLast: true,
        fixedBgPos: true,
        fixedContentPos: true,
        iframe: {
            markup:
                '<div class="mfp-iframe-scaler">' +
                '<button class="mfp-close mfp-custom-close" title="Close (Esc)"></button>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>',
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: 'https://www.youtube.com/embed/%id%?autoplay=1&rel=0',
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1',
                },
            },
            srcAction: 'iframe_src',
        },
    });

    const search_query = getUrlParameter('submit');
    const page_slug = window.location.pathname;
    const check_search_slug = 'search-jobs';

    // Custom select dropdown
    {
        $('.custom-select')
            .each(function (_, customSelectBox) {
                $(customSelectBox).select2({
                    minimumResultsForSearch: Infinity,
                    dropdownParent: $(customSelectBox).parents('.form-group')?.[0] ?? null,
                    closeOnSelect: !customSelectBox.multiple,
                    sorter: function (results) {
                        if ($(customSelectBox).data('sort') == false) {
                            return results;
                        }
                        return results.sort(function (a, b) {
                            return a['selected'] > b['selected'] ? -1 : 1;
                        });
                    },
                });

                // Add custom arrow
                setTimeout(() => {
                    $(customSelectBox)
                        .next('.select2-container')
                        .find('.select2-search--inline')
                        .after('<span class="custom_arrow"></span>');
                }, 300);
            })
            .on('change.select2', function () {
                let select = $(this),
                    ul = select.next('span.select2').find('ul');

                // Set title and aria attributes
                select
                    .next('.select2-container')
                    .find('.select2-search__field')
                    .attr('aria-label', select.data('aria-label'))
                    .attr('title', select.data('aria-description'));

                // Set selected items count in place of placeholder
                ul.find('.select2-selection__choice').remove();
                // Set placeholder
                const count = select.select2('data').length;
                let placeholderText = select.attr('label') ?? select.attr('aria-label');
                // If any item is selected set the placeholder text to show number of selections
                if (count > 0 && select.attr('multiple')) {
                    placeholderText = count > 1 ? `${count} options selected` : `${count} option selected`;
                }

                let formGroup = select.closest('.form-group');
                let searchField = formGroup.find('.select2-search__field');
                let selectionRendered = formGroup.find('.select2-selection__rendered');

                searchField.attr('placeholder', placeholderText);

                if (!searchField.length && $(this).val() == null) {
                    selectionRendered.text(placeholderText);
                }
            })
            .on('select2:open', function (e) {
                setTimeout(() => {
                    $(this).parents('.form-group').find('.select2-selection').removeAttr('role');
                    $(this).parents('.form-group').find('.select2-selection').attr('aria-hidden', 'true');
                    $(this).parents('.form-group').find('.select2-results__options').removeAttr('role');
                    $('.select2-results__option:not(.select2-results__option--selected)').removeAttr('aria-selected');
                }, 300);
            })

            .on('select2:close', function (e) {
                // This is to close the keyboard in mobile devices and fix flickering issue
                const selectSearchBox = $(e.target).next('.select2-container').find('.select2-search__field');
                selectSearchBox.trigger('blur');

                setTimeout(() => {
                    $(this).parents('.form-group').find('.select2-selection').attr('role', 'combobox');
                    $(this).parents('.form-group').find('.select2-selection').attr('aria-hidden', 'false');
                    $(this).parents('.form-group').find('.select2-results__options').attr('role', 'listbox');
                }, 300);
            })
            .trigger('change');

        // In the scrollable element select2 causes glitches, to avoid we will close the dropdown, when user scrolls.
        // This will close the dropdown when user scrolls in the scrollable elements.
        $('.filter-form-wrapper').on('scroll', function () {
            $('.custom-select').select2('close');
        });
    }

    // Handler - Job type
    {
        $(document).on('click', '.search-buttons .btn', function (e) {
            e.preventDefault();
            var val = $(this).data('id');

            if (val == 'external') {
                $('.job-search-type [name="job-type-selector"][value="external"]').trigger('click');
            } else {
                $('.job-search-type [name="job-type-selector"][value="internal"]').trigger('click');
            }
            createCookie(search_area_selector, val);

            // Send jobfeed interest details to notification service
            notificationManager.sendTag('jobfeed_type', val);

            $.magnificPopup.close();
        });

        $(document).on('click', '.pwa-offline .onlineonly-btn', function (e) {
            e.preventDefault();
            return false;
        });

        // Cookie content scroll
        var pageContentHashId = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if (!pageContentHashId === '') {
            $(pageContentHashId).focus();
        }

        $(document).on('click', '.search-popup-wrap .btn', function (e) {
            e.preventDefault();
            var val = $(this).data('id');
            createCookie(search_area_selector, val);

            // Send jobfeed interest details to notification service
            notificationManager.sendTag('jobfeed_type', val);

            $('#home-job-type').val(val);
            $('.search-job-form-container .home-submit').trigger('click');
        });

        $('#job-search-form').on('submit', function (e) {
            e.preventDefault();
            const form = $(this)[0];
            const formData = new FormData(form);

            formData.forEach((value, key) => {
                if (!$.trim(value)) {
                    formData.delete(key);
                    formData.forEach((value, key) => {
                        if (value.trim() === '') {
                            formData.delete(key);
                        }
                    });
                }
            });

            const queryString = new URLSearchParams(formData).toString();
            const actionUrl = form.action + '?' + queryString;
            window.location.href = actionUrl;
        });
    }

    /**
     * Save jobs
     */
    {
        function setSaveJobSectionHeight() {
            const navHeight = $('.nav').outerHeight();
            const footerHeight = $('.footer').outerHeight();
            const windowHeight = $(window).height();
            const saveJobSection = $('.save_listing_wrap, .expired_unsubs_wrap');
            const isDesktopTopMenuVisible = $('.desktop_top_menu').is(':visible');
            const pwaMobileNav = $('.pwa-mobile-nav').is(':visible') ? $('.pwa-mobile-nav').outerHeight() : 0;

            if (saveJobSection.length > 0) {
                let saveJobSectionHeight = windowHeight - footerHeight - navHeight - pwaMobileNav;
                if (isDesktopTopMenuVisible) {
                    saveJobSectionHeight += $('.desktop_top_menu').outerHeight();
                }
                saveJobSectionHeight = Math.round(saveJobSectionHeight);
                saveJobSection.css('min-height', saveJobSectionHeight + 'px');
            }
        }

        setSaveJobSectionHeight();
        $(window).on('resize', setSaveJobSectionHeight);

        $(document).on('click', '.remove-saved', function (e) {
            e.preventDefault();
            $('.save_listing_wrap').prepend('<div class="loader_wrapper"><div class="loader">Loading...</div></div>');
            var val = $(this).data('lead-id');
            var base_url = $(this).data('baseurl');
            var save_list = JSON.parse(readCookie(default_saveletter_cookie));

            if (save_list) {
                const index = save_list.indexOf(val);
                if (index > -1) {
                    save_list.splice(index, 1);
                }
                var add_val = JSON.stringify(save_list);
                createCookie(default_saveletter_cookie, add_val);

                setTimeout(function () {
                    if (typeof window.updatePWAPageCache === 'function') {
                        window.updatePWAPageCache(base_url);
                        window.updatePWAPageCache(homeUrl);
                    }
                    $('.loader_wrapper').remove();
                }, 300);

                $(this).parent().remove();
                if ($('.job-card-list').find('.job-card').length == 0) {
                    var noresultsHtml = '';
                    var btn_url = '';
                    btn_url = homeUrl + '/search-jobs/?submit=1';
                    noresultsHtml =
                        '<div class="zero-results text-center">' +
                        '<h3 class="section-heading">No saved jobs</h3>' +
                        '<p>You have no saved jobs. Start your search by clicking the Search jobs button below.</p>' +
                        '<p><a href="' +
                        btn_url +
                        '" class="btn btn-blue" title="Find out more jobs">Search jobs</a></p>' +
                        '</div>';

                    $('.job-result-section').html(noresultsHtml);
                }
            } else {
            }
            setSaveJobSectionHeight();
        });

        // Handler - Save job
        $(document).on('click', 'a.btn-whishlist', function (e) {
            e.preventDefault();
            const job_id = $(this).data('lead-id');
            const save_list = JSON.parse(readCookie(default_saveletter_cookie)) || [];
            const loader = $('.summary .box-loader');

            loader.show();

            if (!save_list.includes(job_id)) {
                save_list.push(job_id);
                createCookie(default_saveletter_cookie, JSON.stringify(save_list));

                loader.delay(1000).fadeOut(0, 'linear', () => {
                    $.magnificPopup.open({
                        items: {
                            src: '#savejobs-popup-wrap',
                        },
                        type: 'inline',
                        mainClass: 'saved-jobs-modal',
                        closeBtnInside: true,
                        autoFocusLast: true,
                        fixedBgPos: true,
                        fixedContentPos: true,
                    });
                    $(this).addClass('saved-link').html('Saved Job');
                    $('html, body').animate({ scrollTop: 0 }, 200);
                });
            } else {
                const index = save_list.indexOf(job_id);
                if (index > -1) {
                    save_list.splice(index, 1);
                    createCookie(default_saveletter_cookie, JSON.stringify(save_list));
                } else {
                    eraseCookie(default_saveletter_cookie);
                }

                loader.delay(1000).fadeOut(0, 'linear', () => {
                    $(this).removeClass('saved-link').html('Save Job');
                });
            }
            const base_url = $(this).data('baseurl');
            if (typeof window.updatePWAPageCache === 'function') {
                window.updatePWAPageCache(base_url);
                window.updatePWAPageCache(homeUrl);
            }
        });

        // Job detail page - Check if job is already saved
        if ($('body').hasClass('single-jobs')) {
            let is_saveletter_cookie = JSON.parse(readCookie(default_saveletter_cookie));

            if (is_saveletter_cookie) {
                var val = $('.btn-whishlist').data('lead-id');
                if (jQuery.inArray(val, is_saveletter_cookie) !== -1) {
                    $('.btn-whishlist').addClass('saved-link');
                    $('.btn-whishlist').html('Saved Job');
                }
            }
        }
    }

    if ($('body').hasClass('page-template-template-career-area') && navigator.onLine) {
        getLatestJobsCount();
    }

    if (navigator.onLine) {
        getPopularLocations();
    }

    getLastSearchedData();

    if (search_query != true) {
        let is_search_selected = readCookie(search_area_selector);

        if (!is_search_selected && page_slug.indexOf(check_search_slug) != -1) {
            $.magnificPopup.open({
                items: {
                    src: '#search-page-popup-box',
                },
                showCloseBtn: false,
                enableEscapeKey: false,
                closeOnBgClick: false,
                autoFocusLast: true,
                fixedBgPos: true,
                fixedContentPos: true,
            });
        } else {
            setTimeout(() => {
                if (is_search_selected == 'external') {
                    $('.job-search-type [name="job-type-selector"][value="external"]').trigger('click');
                } else {
                    $('.job-search-type [name="job-type-selector"][value="internal"]').trigger('click');
                }
            }, 300);
        }
    } else {
        let is_search_selected = readCookie(search_area_selector);

        if (!is_search_selected && page_slug.indexOf(check_search_slug) != -1) {
            $.magnificPopup.open({
                items: {
                    src: '#search-page-popup-box',
                },
                type: 'inline',
                showCloseBtn: false,
                enableEscapeKey: false,
                closeOnBgClick: false,
                autoFocusLast: true,
                fixedBgPos: true,
                fixedContentPos: true,
            });
        } else {
            setTimeout(() => {
                if (is_search_selected == 'external') {
                    $('.job-search-type [name="job-type-selector"][value="external"]').trigger('click');
                } else {
                    $('.job-search-type [name="job-type-selector"][value="internal"]').trigger('click');
                }
            }, 300);
        }
    }

    /**
     * On scroll element animation
     */
    if ($('.aos-animate').length > 0) {
        // Convert AOS classes to data attributes
        function isMatch(str) {
            let ret = null,
                tab = ['data-aos_', 'data-aos-delay_', 'data-aos-duration_', 'data-aos-easing_', 'data-aos-offset_'];
            Object.values(tab).forEach(function (value) {
                if (String(str).match(value)) {
                    ret = str.split('_');
                    if (value === 'data-aos-delay_') {
                        ret[1] = parseInt(ret[1]) + 400;
                    }
                    return false;
                }
            });
            return ret;
        }
        $('.aos-animate').each(function () {
            const $this = $(this),
                tab = $this.attr('class').split(' ');

            Object.values(tab).forEach(function (item) {
                const ele = isMatch(item);
                if (ele !== null) {
                    if ($this.closest('.image-wrapper').length > 0) {
                        $this.find('img').attr(ele[0], ele[1]).addClass('aos-animate');
                    } else {
                        $this.attr(ele[0], ele[1]);
                    }
                }
            });
        });

        AOS.init({
            startEvent: 'load',
            once: false,
            mirror: true,
            disable: 'mobile',
        });
    }

    // FAQ Accordion
    let fqaContainerScrollTimeout;
    $(document).on('click', '.faq-accordian-question', function () {
        clearTimeout(fqaContainerScrollTimeout);
        const $control = $(this).find('button'),
            $navListSwiper = $('.nav-list-swiper'),
            $wrapper = $(this).closest('.faq-accordian-wrapper'),
            $parent = $(this).closest('.faq-accordian'),
            $accordionItem = $(this).parent(),
            $content = $parent.find('.faq-accordian-content'),
            $headerHeight = $('.nav').outerHeight() +
            $('.desktop_top_menu').outerHeight() + ($navListSwiper.hasClass('swiper-centered') ? $navListSwiper.outerHeight() : 0);

        // Close other accordians in the group
        $wrapper.find('.faq-accordian-question button').attr('aria-expanded', 'false');

        // Open/close clicked accordion
        if (!$(this).parents('.how-applay-faq').length > 0) {
            $wrapper.find('.faq-accordian').not($parent).removeClass('active');
            $wrapper.find('.faq-accordian-content').not($content).slideUp();
            $parent.toggleClass('active');
            $content.slideToggle('fast', function () {
                if ($(this).is(':visible')) {
                    $(this).css('display', 'flex');
                }
            });

            setTimeout(() => {
                $('html, body').animate(
                    {
                        scrollTop: $accordionItem.offset().top - $headerHeight,
                    },
                    800
                );
            }, 500);
        } else {
            $(this).parents('.how-applay-faq').find('.faq-accordian-content').slideToggle();
            $(this).closest('.how-applay-faq').find('.faq-accordian').toggleClass('active');
            setTimeout(() => {
                $(this)
                    .parents('.how-applay-faq')
                    .find('.faq-question-label')
                    .attr('aria-expanded', function (_, attr) {
                        return attr === 'true' ? 'false' : 'true';
                    });
            }, 100);
        }
        $control.attr('aria-expanded', $parent.hasClass('active'));
    });

    $(document).on('click', '.faq-accordian-content .multiple_answer a', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        document.querySelector(href).scrollIntoView({ behavior: 'smooth', block: 'center' });
        $(href).attr('tabindex', '-1').focus();
    });

    $('.faq-accordian-content .multiple_answer a').each(function () {
        let hrefText = $(this).text();
        let moreText = $($(this).attr('href')).find('h2').text();
        $(this).attr('aria-label', `this link navigates to ${moreText}`);
    });

    $('.vertical-slides').append(
        '<div class="swiper-pagination vertical-pagination"></div><button class="swiper-button-next vertical-next-btn" tabindex="1"><span>Scroll down</span></button>'
    );

    // Sub-menu position dynamic
    $('.sub-menu .menu-item-has-children').on('mouseenter focusin', function () {
        var subMenu = $(this).find('.sub-menu');
        var subMenuHeight = subMenu.outerHeight();
        var headerHeight = $('nav').outerHeight();
        var offsetTop = $(this).position().top;
        var totatPx = subMenuHeight + headerHeight + offsetTop;
        var positionPx = totatPx - $(window).height() + 10;
        var winheight = $(window).height();
        if (totatPx > winheight) {
            $(subMenu).css('top', '-' + positionPx + 'px');
        }
    });

    $('.menu-item-has-children').on('mouseenter focusin', function () {
        $(this).siblings('.menu-item-has-children').find('a').blur();
    });
    const toggleAnchor = $('.footer-toggle-btn').find('a');
    const toggleFooter = $('#toggle-footer');
    toggleAnchor.attr('role', 'button');
    toggleAnchor.attr('aria-expanded', 'false');

    $('.footer-toggle-btn').on('click', function (event) {
        event.preventDefault();
        $('.footer-toggle-btn').toggleClass('open');
        toggleFooter.slideToggle(200);
        $('html, body').animate(
            {
                scrollTop: toggleFooter.offset().top,
            },
            200
        );
        if ($(this).hasClass('open')) {
            toggleAnchor.attr('aria-expanded', 'true');
            toggleFooter.attr('tabindex', '-1').focus();
        } else {
            toggleAnchor.attr('aria-expanded', 'false');
            toggleFooter.removeAttr('tabindex');
        }
    });

    // Adway application tracking on kenexa link clicks
    $(document).on('click', 'body:not(.pwa-offline) .kenexa-apply-button', function () {
        if (window.adway) {
            adway.event.applyStarted();
        }
    });
    $(document).on('input', '.validate_location', function (e) {
        var inputElement = $(this);
        var errorMessageElement = $('.errorMessage');
        var inputValue = inputElement.val();

        //var specialCharacterRegex = /[^a-zA-Z0-9,+\\-\s]/;
        if (specialCharacterRegex.test(inputValue)) {
            errorMessageElement.text('Only special characters , - or + are permitted.');
            inputElement.val(inputValue.replace(specialCharacterRegex, '')); // Remove special characters
            inputElement.addClass('invalid-input');
            setTimeout(() => {
                inputElement.removeClass('invalid-input');
                errorMessageElement.text('');
            }, 3000);
            return;
        }
        inputElement.removeClass('invalid-input');
        errorMessageElement.text(''); // Clear error message
    });
    $('.validate_location').on('paste', function (event) {
        var inputElement = $(this);
        var clipboardData = event.originalEvent.clipboardData || window.clipboardData;
        var pastedData = clipboardData.getData('text');

        var filteredData = pastedData.replace(specialCharacterRegex, '');

        inputElement.val('');

        inputElement.trigger('input');
    });

    //scroll-to-top
    const btnScrollTop = $('.scroll-to-top');

    $(window).on('scroll load', function (e) {
        if ($(window).scrollTop() > 300) {
            btnScrollTop.addClass('show');
        } else {
            btnScrollTop.removeClass('show');
        }
    });

    btnScrollTop.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, '300');
    });

    /**
     * Calculate header height and secodary height and set in css variable
     */
    let headerTotalHeight = $('nav.nav').outerHeight(true) || 0;

    // Add secondary header height
    headerTotalHeight += jQuery('.sticky-nav').outerHeight(true) || 0;

    document.body.style.setProperty('--header-height', `${headerTotalHeight}px`);

    // Category/tag/archive dropdown
    $('.category-tag-dropdown select').on('change', function () {
        window.location.href = $(this).val();
    });

    // Show/hide vacancy CTA on scroll once footer/social section is reached
    function toggleVisibility($element, threshold) {
        var scrollBottom = $(window).scrollTop() + $(window).height();
        var footerOffset = $('footer')?.offset()?.top;
        var socialSectionOffset = $('.social-section')?.offset()?.top;

        if ($(window).width() <= 768) {
            if (scrollBottom > footerOffset + threshold || scrollBottom > socialSectionOffset + threshold) {
                $element.addClass('hide-vacancy-cta');
                $element.attr('tabindex', '-1');
                $element.find('a').attr('tabindex', '-1');
            } else {
                $element.removeClass('hide-vacancy-cta');
                $element.removeAttr('tabindex');
                $element.find('a').removeAttr('tabindex');
            }
        }
    }

    $(window).scroll(function () {
        toggleVisibility($('.page-template-template-career-area .career-head-wrapper .btn-wrapper .btn.blue-bg'), 40);
        toggleVisibility($('.summary .btns-wrapper'), 0);
    });

    /**
     * PWA jQuery based code.
     * We have to use jQuery for few PWA functionalites as pwa.js file is preloaded before jQuery.
     */
    // For all internal links, show the pace loader.
    $('body').on('click', 'a', function (e) {
        if(this.target === '_blank' || e.ctrlKey) return;

        // Check if link is internal and not a link with "#" or "javascript:void(0)"
        if (
            this.hostname === window.location.hostname &&
            this.href !== window.location.href && // Exclude links to the same URL
            this.href !== window.location.origin + '/' && // Exclude homepage anchor links ("/")
            !/^#/.test(this.getAttribute('href')) && // Exclude "#" links
            !/javascript:void\(0\)/.test(this.getAttribute('href'))
        ) {
            // Exclude "javascript:void(0)"

            window.updatePageLoadingState(true);
            Pace.restart();
        }
    });
    $(document).ready(function () {
        const breadcrumbLast = $('.breadcrumb-wrap .breadcrumb_last');
        const breadcrumbText = breadcrumbLast.text().trim();
        const anchor = $('<a></a>')
            .attr({
                href: 'javascript:void(0);',
                role: 'presentation',
                'aria-label': `${breadcrumbText} current page`,
            })
            .text(breadcrumbText);
        breadcrumbLast.empty().append(anchor);
    });
    $('.breadcrumb_last').removeAttr('aria-current');
    // Generic function to handle tabindex for Swiper slides
    function updateTabIndexForSlides(swiper, breakpoint = 992) {
        const isSmallScreen = window.innerWidth < breakpoint;

        // Check if slides exist before looping
        if (!swiper.slides || swiper.slides.length === 0) return;

        swiper.slides.forEach((slide) => {
            if (isSmallScreen) {
                slide.setAttribute('tabindex', '0');
            } else {
                slide.removeAttribute('tabindex');
            }
        });
    }

    // Select the button within the parent element
    $('.mfp-iframe-scaler .mfp-close').attr('aria-label', 'Close');
})(jQuery);
